import { render, staticRenderFns } from "./masterpaket.vue?vue&type=template&id=1b8d3ca5"
import script from "./masterpaket.vue?vue&type=script&lang=js"
export * from "./masterpaket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports